'use client';
import React from 'react';
import { TestimonialCarousel as SharedTestimonialCarousel } from '@launchstore/shared-puck';

export const TestimonialCarousel: any = SharedTestimonialCarousel;
export default TestimonialCarousel;
